import { CompositeWriteRepository, getWriteRoutingConfigFromEnv } from './repositories/CompositeWriteRepository';
import { FirestoreWriteRepository } from './repositories/FirestoreWriteRepository';
import { HttpApiWriteRepository } from './repositories/HttpApiWriteRepository';

export const writeRepository = new CompositeWriteRepository({
  firestoreRepo: new FirestoreWriteRepository(),
  apiRepo: new HttpApiWriteRepository(),
  routing: getWriteRoutingConfigFromEnv(process.env)
});
